module.exports = __webpack_public_path__ + "static/media/help-question.86be9c4b.svg";